// GENERATED FILE — do not edit by hand.
// Run `yarn generate:logos` after changing frontend/static/logos/ or
// logos/labels.json. See logos/README.md.

/** Every logo committed to frontend/static/logos/, rendered as /logos/{id}.png */
export type LogoId =
  | '1800contacts'
  | '5ive_spice'
  | '85c_bakery'
  | '99_ranch'
  | 'aaa'
  | 'adobe'
  | 'aesop'
  | 'air_canada'
  | 'airbnb'
  | 'alamo_drafthouse'
  | 'alaska'
  | 'ally'
  | 'amazon'
  | 'american_airlines'
  | 'amex'
  | 'anthropic'
  | 'apple'
  | 'arcteryx'
  | 'asiana'
  | 'backcountry'
  | 'barclays'
  | 'barnes_noble'
  | 'bed_bath_beyond'
  | 'bellagio'
  | 'berkeley_bowl'
  | 'best_buy'
  | 'bh_photo'
  | 'big_sky'
  | 'blank_street'
  | 'blue_apron'
  | 'blue_bottle'
  | 'bluestone_lane'
  | 'boa'
  | 'bombas'
  | 'bond_vet'
  | 'breckenridge'
  | 'brooklyn_paramount'
  | 'burger_king'
  | 'capital_one'
  | 'cava'
  | 'centurylink'
  | 'chargepoint'
  | 'chase'
  | 'chelsea_piers'
  | 'chevron'
  | 'chewy'
  | 'chipotle'
  | 'cigna'
  | 'citi'
  | 'classpass'
  | 'claude'
  | 'cnb'
  | 'coinbase'
  | 'coned'
  | 'container_store'
  | 'cosmopolitan'
  | 'costco'
  | 'court16'
  | 'cvs'
  | 'dell'
  | 'delta'
  | 'design_within_reach'
  | 'dicks'
  | 'didi'
  | 'digitalocean'
  | 'din_tai_fung'
  | 'doordash'
  | 'dropbox'
  | 'dunkin'
  | 'dyson'
  | 'eataly'
  | 'emmy_squared'
  | 'eq3'
  | 'espresso_vivace'
  | 'expedia'
  | 'exxonmobil'
  | 'ezpass'
  | 'facebook'
  | 'fandango'
  | 'fastmail'
  | 'fastrak'
  | 'fedex'
  | 'fidelity'
  | 'first_republic'
  | 'five_guys'
  | 'geico'
  | 'gong_cha'
  | 'goodtogo'
  | 'google'
  | 'grab'
  | 'h_mart'
  | 'haidilao'
  | 'hertz'
  | 'heytea'
  | 'hinge'
  | 'holafly'
  | 'home_depot'
  | 'ikea'
  | 'irs'
  | 'jetblue'
  | 'jr_central'
  | 'juniors'
  | 'just_salad'
  | 'kiehls'
  | 'klook'
  | 'korail'
  | 'krispy_kreme'
  | 'lego'
  | 'lemonade'
  | 'life_time'
  | 'lime'
  | 'luckin'
  | 'lululemon'
  | 'lyft'
  | 'madewell'
  | 'max'
  | 'mcdonalds'
  | 'meowtel'
  | 'microsoft'
  | 'molly_moon'
  | 'mox'
  | 'mta'
  | 'muji'
  | 'nenes_taqueria'
  | 'netflix'
  | 'new_york_life'
  | 'nintendo'
  | 'nyc_finance'
  | 'nyrr'
  | 'nytimes'
  | 'obe_fitness'
  | 'one_medical'
  | 'openai'
  | 'paris_baguette'
  | 'partners_coffee'
  | 'patreon'
  | 'pax'
  | 'paypal'
  | 'petco'
  | 'philz'
  | 'plaid'
  | 'progressive'
  | 'pseg'
  | 'qfc'
  | 'rakuten'
  | 'ratp'
  | 'rei'
  | 'render'
  | 'riot_games'
  | 'safeway'
  | 'saks'
  | 'salt_and_straw'
  | 'sbp'
  | 'schwab'
  | 'seats_aero'
  | 'seattle_city_light'
  | 'seattle_coffee_works'
  | 'seven_eleven'
  | 'shell'
  | 'shoppers_drug_mart'
  | 'shoprite'
  | 'southwest'
  | 'splitwise'
  | 'spotify'
  | 'staples'
  | 'starbucks'
  | 'state_farm'
  | 'steam'
  | 'stewarts_shops'
  | 'stowe'
  | 'stripe'
  | 'stumptown'
  | 'summit_snoqualmie'
  | 'sweetgreen'
  | 't_mobile'
  | 'taim'
  | 'target'
  | 'taskrabbit'
  | 'tennis_warehouse'
  | 'tesla'
  | 'the_sill'
  | 'ticketmaster'
  | 'tim_hortons'
  | 'tj_maxx'
  | 'trade_coffee'
  | 'trader_joes'
  | 'treasury_direct'
  | 'uber'
  | 'uber_eats'
  | 'uhaul'
  | 'uniqlo'
  | 'united'
  | 'ups'
  | 'us_bank'
  | 'usps'
  | 'uwajimaya'
  | 'van_leeuwen'
  | 'venmo'
  | 'verizon'
  | 'vrbo'
  | 'vsp'
  | 'walgreens'
  | 'walmart'
  | 'wayfair'
  | 'waymo'
  | 'wealthfront'
  | 'wegmans'
  | 'wendys'
  | 'wework'
  | 'whole_foods'
  | 'wyze'
  | 'youtube'
  | 'zipcar';

export type LogoOption = {value: LogoId | ''; label: string};

/** '' is the "no logo" choice, so this is safe to bind straight to a picker. */
export const LOGO_OPTIONS: readonly LogoOption[] = [
  {value: '', label: 'None'},
  {value: '1800contacts', label: '1-800 Contacts'},
  {value: '5ive_spice', label: '5ive Spice'},
  {value: '85c_bakery', label: '85C Bakery'},
  {value: '99_ranch', label: '99 Ranch'},
  {value: 'aaa', label: 'AAA'},
  {value: 'adobe', label: 'Adobe'},
  {value: 'aesop', label: 'Aesop'},
  {value: 'air_canada', label: 'Air Canada'},
  {value: 'airbnb', label: 'Airbnb'},
  {value: 'alamo_drafthouse', label: 'Alamo Drafthouse'},
  {value: 'alaska', label: 'Alaska Airlines'},
  {value: 'ally', label: 'Ally'},
  {value: 'amazon', label: 'Amazon'},
  {value: 'american_airlines', label: 'American Airlines'},
  {value: 'amex', label: 'American Express'},
  {value: 'anthropic', label: 'Anthropic'},
  {value: 'apple', label: 'Apple'},
  {value: 'arcteryx', label: "Arc'teryx"},
  {value: 'asiana', label: 'Asiana Airlines'},
  {value: 'backcountry', label: 'Backcountry'},
  {value: 'barclays', label: 'Barclays'},
  {value: 'barnes_noble', label: 'Barnes & Noble'},
  {value: 'bed_bath_beyond', label: 'Bed Bath & Beyond'},
  {value: 'bellagio', label: 'Bellagio'},
  {value: 'berkeley_bowl', label: 'Berkeley Bowl'},
  {value: 'best_buy', label: 'Best Buy'},
  {value: 'bh_photo', label: 'B&H Photo'},
  {value: 'big_sky', label: 'Big Sky Resort'},
  {value: 'blank_street', label: 'Blank Street Coffee'},
  {value: 'blue_apron', label: 'Blue Apron'},
  {value: 'blue_bottle', label: 'Blue Bottle'},
  {value: 'bluestone_lane', label: 'Bluestone Lane'},
  {value: 'boa', label: 'Bank of America'},
  {value: 'bombas', label: 'Bombas'},
  {value: 'bond_vet', label: 'Bond Vet'},
  {value: 'breckenridge', label: 'Breckenridge'},
  {value: 'brooklyn_paramount', label: 'Brooklyn Paramount'},
  {value: 'burger_king', label: 'Burger King'},
  {value: 'capital_one', label: 'Capital One'},
  {value: 'cava', label: 'Cava'},
  {value: 'centurylink', label: 'CenturyLink'},
  {value: 'chargepoint', label: 'ChargePoint'},
  {value: 'chase', label: 'Chase'},
  {value: 'chelsea_piers', label: 'Chelsea Piers Fitness'},
  {value: 'chevron', label: 'Chevron'},
  {value: 'chewy', label: 'Chewy'},
  {value: 'chipotle', label: 'Chipotle'},
  {value: 'cigna', label: 'Cigna'},
  {value: 'citi', label: 'Citi'},
  {value: 'classpass', label: 'Classpass'},
  {value: 'claude', label: 'Claude'},
  {value: 'cnb', label: 'City National Bank'},
  {value: 'coinbase', label: 'Coinbase'},
  {value: 'coned', label: 'ConEd'},
  {value: 'container_store', label: 'Container Store'},
  {value: 'cosmopolitan', label: 'Cosmopolitan'},
  {value: 'costco', label: 'Costco'},
  {value: 'court16', label: 'Court 16'},
  {value: 'cvs', label: 'CVS'},
  {value: 'dell', label: 'Dell'},
  {value: 'delta', label: 'Delta'},
  {value: 'design_within_reach', label: 'Design Within Reach'},
  {value: 'dicks', label: "Dick's"},
  {value: 'didi', label: 'Didi'},
  {value: 'digitalocean', label: 'DigitalOcean'},
  {value: 'din_tai_fung', label: 'Din Tai Fung'},
  {value: 'doordash', label: 'Doordash'},
  {value: 'dropbox', label: 'Dropbox'},
  {value: 'dunkin', label: "Dunkin' Donuts"},
  {value: 'dyson', label: 'Dyson'},
  {value: 'eataly', label: 'Eataly'},
  {value: 'emmy_squared', label: 'Emmy Squared Pizza'},
  {value: 'eq3', label: 'EQ3'},
  {value: 'espresso_vivace', label: 'Espresso Vivace'},
  {value: 'expedia', label: 'Expedia'},
  {value: 'exxonmobil', label: 'ExxonMobil'},
  {value: 'ezpass', label: 'E-ZPass'},
  {value: 'facebook', label: 'Facebook Marketplace'},
  {value: 'fandango', label: 'Fandango'},
  {value: 'fastmail', label: 'Fastmail'},
  {value: 'fastrak', label: 'Fastrak'},
  {value: 'fedex', label: 'FedEx'},
  {value: 'fidelity', label: 'Fidelity'},
  {value: 'first_republic', label: 'First Republic'},
  {value: 'five_guys', label: 'Five Guys'},
  {value: 'geico', label: 'Geico'},
  {value: 'gong_cha', label: 'Gong Cha'},
  {value: 'goodtogo', label: 'GoodToGo'},
  {value: 'google', label: 'Google'},
  {value: 'grab', label: 'Grab'},
  {value: 'h_mart', label: 'H Mart'},
  {value: 'haidilao', label: 'Hai Di Lao'},
  {value: 'hertz', label: 'Hertz'},
  {value: 'heytea', label: 'Heytea'},
  {value: 'hinge', label: 'Hinge'},
  {value: 'holafly', label: 'Holafly'},
  {value: 'home_depot', label: 'Home Depot'},
  {value: 'ikea', label: 'Ikea'},
  {value: 'irs', label: 'IRS'},
  {value: 'jetblue', label: 'JetBlue'},
  {value: 'jr_central', label: 'JR Central'},
  {value: 'juniors', label: "Junior's Cheesecake"},
  {value: 'just_salad', label: 'Just Salad'},
  {value: 'kiehls', label: "Kiehl's"},
  {value: 'klook', label: 'Klook'},
  {value: 'korail', label: 'Korail'},
  {value: 'krispy_kreme', label: 'Krispy Kreme'},
  {value: 'lego', label: 'Lego'},
  {value: 'lemonade', label: 'Lemonade'},
  {value: 'life_time', label: 'Life Time'},
  {value: 'lime', label: 'Lime'},
  {value: 'luckin', label: 'Luckin Coffee'},
  {value: 'lululemon', label: 'Lululemon'},
  {value: 'lyft', label: 'Lyft'},
  {value: 'madewell', label: 'Madewell'},
  {value: 'max', label: 'HBO Max'},
  {value: 'mcdonalds', label: "McDonald's"},
  {value: 'meowtel', label: 'Meowtel'},
  {value: 'microsoft', label: 'Microsoft Store'},
  {value: 'molly_moon', label: "Molly Moon's"},
  {value: 'mox', label: 'Mox Boarding House'},
  {value: 'mta', label: 'MTA'},
  {value: 'muji', label: 'Muji'},
  {value: 'nenes_taqueria', label: "Nene's Taqueria"},
  {value: 'netflix', label: 'Netflix'},
  {value: 'new_york_life', label: 'New York Life'},
  {value: 'nintendo', label: 'Nintendo'},
  {value: 'nyc_finance', label: 'NYC Finance'},
  {value: 'nyrr', label: 'NYRR'},
  {value: 'nytimes', label: 'New York Times'},
  {value: 'obe_fitness', label: 'Obe Fitness'},
  {value: 'one_medical', label: 'One Medical'},
  {value: 'openai', label: 'OpenAI'},
  {value: 'paris_baguette', label: 'Paris Baguette'},
  {value: 'partners_coffee', label: 'Partners Coffee'},
  {value: 'patreon', label: 'Patreon'},
  {value: 'pax', label: 'PAX'},
  {value: 'paypal', label: 'PayPal'},
  {value: 'petco', label: 'Petco'},
  {value: 'philz', label: 'Philz Coffee'},
  {value: 'plaid', label: 'Plaid'},
  {value: 'progressive', label: 'Progressive'},
  {value: 'pseg', label: 'PSEG'},
  {value: 'qfc', label: 'QFC'},
  {value: 'rakuten', label: 'Rakuten'},
  {value: 'ratp', label: 'RATP'},
  {value: 'rei', label: 'REI'},
  {value: 'render', label: 'Render'},
  {value: 'riot_games', label: 'Riot Games'},
  {value: 'safeway', label: 'Safeway'},
  {value: 'saks', label: 'Saks Fifth Avenue'},
  {value: 'salt_and_straw', label: 'Salt & Straw'},
  {value: 'sbp', label: 'Seattle Bouldering Project'},
  {value: 'schwab', label: 'Schwab'},
  {value: 'seats_aero', label: 'seats.aero'},
  {value: 'seattle_city_light', label: 'Seattle City Light'},
  {value: 'seattle_coffee_works', label: 'Seattle Coffee Works'},
  {value: 'seven_eleven', label: '7-Eleven'},
  {value: 'shell', label: 'Shell'},
  {value: 'shoppers_drug_mart', label: 'Shoppers Drug Mart'},
  {value: 'shoprite', label: 'Shoprite'},
  {value: 'southwest', label: 'Southwest'},
  {value: 'splitwise', label: 'Splitwise'},
  {value: 'spotify', label: 'Spotify'},
  {value: 'staples', label: 'Staples'},
  {value: 'starbucks', label: 'Starbucks'},
  {value: 'state_farm', label: 'State Farm'},
  {value: 'steam', label: 'Steam'},
  {value: 'stewarts_shops', label: "Stewart's Shops"},
  {value: 'stowe', label: 'Stowe'},
  {value: 'stripe', label: 'Stripe'},
  {value: 'stumptown', label: 'Stumptown Coffee'},
  {value: 'summit_snoqualmie', label: 'The Summit at Snoqualmie'},
  {value: 'sweetgreen', label: 'Sweetgreen'},
  {value: 't_mobile', label: 'T-Mobile'},
  {value: 'taim', label: 'Taim'},
  {value: 'target', label: 'Target'},
  {value: 'taskrabbit', label: 'Taskrabbit'},
  {value: 'tennis_warehouse', label: 'Tennis Warehouse'},
  {value: 'tesla', label: 'Tesla'},
  {value: 'the_sill', label: 'The Sill'},
  {value: 'ticketmaster', label: 'Ticketmaster'},
  {value: 'tim_hortons', label: 'Tim Hortons'},
  {value: 'tj_maxx', label: 'T.J.Maxx'},
  {value: 'trade_coffee', label: 'Trade Coffee'},
  {value: 'trader_joes', label: "Trader Joe's"},
  {value: 'treasury_direct', label: 'TreasuryDirect'},
  {value: 'uber', label: 'Uber'},
  {value: 'uber_eats', label: 'Uber Eats'},
  {value: 'uhaul', label: 'U-Haul'},
  {value: 'uniqlo', label: 'Uniqlo'},
  {value: 'united', label: 'United Airlines'},
  {value: 'ups', label: 'UPS'},
  {value: 'us_bank', label: 'US Bank'},
  {value: 'usps', label: 'USPS'},
  {value: 'uwajimaya', label: 'Uwajimaya'},
  {value: 'van_leeuwen', label: 'Van Leeuwen Ice Cream'},
  {value: 'venmo', label: 'Venmo'},
  {value: 'verizon', label: 'Verizon'},
  {value: 'vrbo', label: 'VRBO'},
  {value: 'vsp', label: 'VSP'},
  {value: 'walgreens', label: 'Walgreens'},
  {value: 'walmart', label: 'Walmart'},
  {value: 'wayfair', label: 'Wayfair'},
  {value: 'waymo', label: 'Waymo'},
  {value: 'wealthfront', label: 'Wealthfront'},
  {value: 'wegmans', label: 'Wegmans'},
  {value: 'wendys', label: "Wendy's"},
  {value: 'wework', label: 'WeWork'},
  {value: 'whole_foods', label: 'Whole Foods'},
  {value: 'wyze', label: 'Wyze'},
  {value: 'youtube', label: 'YouTube'},
  {value: 'zipcar', label: 'Zipcar'},
];

/**
 * Logos that are a light mark on transparency, so a white tile would render
 * them invisible. Everything else is either opaque (carrying its own
 * background, where the tile never shows) or a dark mark that needs the white
 * tile to stay legible in dark mode. Generated by logos/backgrounds.mjs.
 */
export const LOGOS_NEEDING_DARK_TILE: ReadonlySet<LogoId> = new Set([
  'cava',
  'treasury_direct',
]);

export const LOGO_IDS: readonly LogoId[] = LOGO_OPTIONS.flatMap((option) =>
  option.value === '' ? [] : [option.value],
);

const LOGO_ID_SET: ReadonlySet<string> = new Set(LOGO_IDS);

/**
 * Narrow an arbitrary string — a value read from the database, which is typed
 * as a plain string and predates this union — to a known LogoId.
 */
export const isLogoId = (value: string | null | undefined): value is LogoId =>
  value != null && LOGO_ID_SET.has(value);

/**
 * Content tag per logo: the first 8 hex of the file's sha256.
 *
 * Logo files are not content-hashed the way Parcel hashes bundles, because
 * the slug is the API — the database stores it and the server validates
 * against it — so the tag rides in the query string instead. It changes only
 * when the bytes change, which is what lets the server serve /logos/ as
 * immutable: a replaced logo gets a new URL, an unchanged one is never
 * re-fetched.
 */
const LOGO_VERSIONS: ReadonlyMap<string, string> = new Map([
  ['1800contacts', '69595f33'],
  ['5ive_spice', '34276877'],
  ['85c_bakery', '1e9ad0f6'],
  ['99_ranch', 'ba551ae4'],
  ['aaa', 'b34934bb'],
  ['adobe', '77db37b7'],
  ['aesop', '99b91b88'],
  ['air_canada', '88810019'],
  ['airbnb', 'a40e1f95'],
  ['alamo_drafthouse', 'c5e8f9c0'],
  ['alaska', 'b049b213'],
  ['ally', 'b8fc8453'],
  ['amazon', '67222b38'],
  ['american_airlines', '8d03cdc2'],
  ['amex', '52e54ecb'],
  ['anthropic', '83a13746'],
  ['apple', '56389c79'],
  ['arcteryx', 'dbecaecd'],
  ['asiana', 'd8658de8'],
  ['backcountry', 'c719dd1e'],
  ['barclays', '831cd2e6'],
  ['barnes_noble', 'fffacf32'],
  ['bed_bath_beyond', '17d446f5'],
  ['bellagio', 'f7ad90aa'],
  ['berkeley_bowl', '49ea8e9c'],
  ['best_buy', '55e96801'],
  ['bh_photo', '54263405'],
  ['big_sky', '7ed4a71c'],
  ['blank_street', '2938ecd3'],
  ['blue_apron', '82246fc0'],
  ['blue_bottle', 'db73f5c7'],
  ['bluestone_lane', '9a6d177d'],
  ['boa', '9291f1e5'],
  ['bombas', '2d949591'],
  ['bond_vet', 'b7519ead'],
  ['breckenridge', 'bf41e908'],
  ['brooklyn_paramount', '7a334aca'],
  ['burger_king', 'fca821a7'],
  ['capital_one', '26d962e7'],
  ['cava', 'aef0d051'],
  ['centurylink', 'b4db2373'],
  ['chargepoint', '6c6a9e96'],
  ['chase', '8c3086a4'],
  ['chelsea_piers', 'df29989b'],
  ['chevron', '86ee2eca'],
  ['chewy', '5b3df40c'],
  ['chipotle', '5e2fd706'],
  ['cigna', 'f464844a'],
  ['citi', '9051e3c1'],
  ['classpass', '65fe86e3'],
  ['claude', '2f93a46d'],
  ['cnb', 'c013b202'],
  ['coinbase', 'bf66ec6b'],
  ['coned', '6b70e916'],
  ['container_store', 'ce361231'],
  ['cosmopolitan', '876af6de'],
  ['costco', '5957fdd5'],
  ['court16', '07813b7b'],
  ['cvs', 'd1a7eb38'],
  ['dell', '7f7892cd'],
  ['delta', '0a9c5dfb'],
  ['design_within_reach', '55628452'],
  ['dicks', 'cceeb678'],
  ['didi', 'cc9a2a1c'],
  ['digitalocean', '673c1a78'],
  ['din_tai_fung', '8ed96462'],
  ['doordash', '86fdb675'],
  ['dropbox', '037f1c3b'],
  ['dunkin', '5c557ae1'],
  ['dyson', '71414334'],
  ['eataly', 'd9900662'],
  ['emmy_squared', '49f2d8b2'],
  ['eq3', '746da4a1'],
  ['espresso_vivace', '556a4c7f'],
  ['expedia', '8e6ed90e'],
  ['exxonmobil', '2650df9b'],
  ['ezpass', '9127ff86'],
  ['facebook', '87d709c5'],
  ['fandango', '6887dc52'],
  ['fastmail', '9248daf0'],
  ['fastrak', 'b7d79fa2'],
  ['fedex', 'b8691c54'],
  ['fidelity', 'a1099ba3'],
  ['first_republic', '156da0ca'],
  ['five_guys', '199257d4'],
  ['geico', '4534eb74'],
  ['gong_cha', 'b1d35152'],
  ['goodtogo', 'dbf988a6'],
  ['google', '69f45460'],
  ['grab', '1abfc274'],
  ['h_mart', '249d2587'],
  ['haidilao', '3b48af1b'],
  ['hertz', '24ccdd7f'],
  ['heytea', 'ddf6ce71'],
  ['hinge', '3e1f4c13'],
  ['holafly', '26b9bcc5'],
  ['home_depot', '15ebcbbf'],
  ['ikea', '97dd5aed'],
  ['irs', '4ae0ee3d'],
  ['jetblue', '32e4ff2d'],
  ['jr_central', 'fa0af1cc'],
  ['juniors', '3ff7be22'],
  ['just_salad', '906f3c2e'],
  ['kiehls', '096dcaa3'],
  ['klook', '38b55d9a'],
  ['korail', '8315096a'],
  ['krispy_kreme', 'e59cb0c0'],
  ['lego', '0e9ccd50'],
  ['lemonade', 'd4d3ab18'],
  ['life_time', '90e43973'],
  ['lime', '9152323b'],
  ['luckin', 'adde1846'],
  ['lululemon', 'e5389e7a'],
  ['lyft', 'a3676fc0'],
  ['madewell', 'b283bc68'],
  ['max', '8121d91d'],
  ['mcdonalds', 'a31c025d'],
  ['meowtel', 'faa6a281'],
  ['microsoft', 'ab733ed6'],
  ['molly_moon', '729fd969'],
  ['mox', 'f5ab4a4c'],
  ['mta', '13ca082c'],
  ['muji', '2daf7660'],
  ['nenes_taqueria', '7ae07a4e'],
  ['netflix', 'e7e50d77'],
  ['new_york_life', '699de547'],
  ['nintendo', '6e52dcca'],
  ['nyc_finance', '2a4f0a89'],
  ['nyrr', '647a2b3f'],
  ['nytimes', 'b16927b9'],
  ['obe_fitness', 'ade7d08c'],
  ['one_medical', 'd5afa03a'],
  ['openai', '335b85cf'],
  ['paris_baguette', 'b4abc43e'],
  ['partners_coffee', '970101aa'],
  ['patreon', '5bfaa43b'],
  ['pax', '08b7e47e'],
  ['paypal', '504c6a0c'],
  ['petco', 'e712a9b5'],
  ['philz', '05a5dd3f'],
  ['plaid', '213f5e35'],
  ['progressive', '7579aaa1'],
  ['pseg', '58ea5a45'],
  ['qfc', '48bec78c'],
  ['rakuten', 'bcc31b79'],
  ['ratp', '7dee9fdb'],
  ['rei', 'cd62ca12'],
  ['render', '74a9eecb'],
  ['riot_games', '607bcb43'],
  ['safeway', 'e0d6f20b'],
  ['saks', '62d7f97a'],
  ['salt_and_straw', '700d340f'],
  ['sbp', '8062517b'],
  ['schwab', 'ada86324'],
  ['seats_aero', 'a22bd9d1'],
  ['seattle_city_light', 'df1c8c9b'],
  ['seattle_coffee_works', '637542a8'],
  ['seven_eleven', '3b563219'],
  ['shell', '3b27e677'],
  ['shoppers_drug_mart', 'd72e8c57'],
  ['shoprite', '979bfc29'],
  ['southwest', 'caf02cec'],
  ['splitwise', '434f0de3'],
  ['spotify', '29c069c4'],
  ['staples', 'f715c7d4'],
  ['starbucks', 'be7df4ca'],
  ['state_farm', '2b3b9ed8'],
  ['steam', '740034d9'],
  ['stewarts_shops', 'cc447547'],
  ['stowe', '6523ae83'],
  ['stripe', 'fe14e67e'],
  ['stumptown', '1e2aa3fe'],
  ['summit_snoqualmie', '32da24cc'],
  ['sweetgreen', '9db3646e'],
  ['t_mobile', 'fd0db42d'],
  ['taim', 'ef87a46f'],
  ['target', 'a24b2138'],
  ['taskrabbit', 'd31654dd'],
  ['tennis_warehouse', 'feceb10d'],
  ['tesla', '4689e5e3'],
  ['the_sill', 'fb78c48e'],
  ['ticketmaster', '2a392f17'],
  ['tim_hortons', '2d7adb18'],
  ['tj_maxx', 'e7e4b246'],
  ['trade_coffee', 'd3fcc568'],
  ['trader_joes', 'cece8153'],
  ['treasury_direct', '4593f1b9'],
  ['uber', 'e154b2b8'],
  ['uber_eats', 'd124db59'],
  ['uhaul', 'ac5a4cba'],
  ['uniqlo', 'a1acf902'],
  ['united', '2f398266'],
  ['ups', '149ed08d'],
  ['us_bank', 'aa69eadb'],
  ['usps', '70482f05'],
  ['uwajimaya', '36d10ec7'],
  ['van_leeuwen', '7869b9ec'],
  ['venmo', 'd67d5491'],
  ['verizon', '3ae5937f'],
  ['vrbo', 'd450ff44'],
  ['vsp', 'b4e75e18'],
  ['walgreens', 'fad7a3bc'],
  ['walmart', 'b49e77ea'],
  ['wayfair', '813e680c'],
  ['waymo', 'b694a2ed'],
  ['wealthfront', '0d4c8781'],
  ['wegmans', '8352d7c8'],
  ['wendys', 'd7680382'],
  ['wework', '45cb301f'],
  ['whole_foods', 'ae4755ce'],
  ['wyze', 'd58aecba'],
  ['youtube', '40eff1cb'],
  ['zipcar', '3fee8efe'],
]);

/**
 * URL for a logo slug, tagged with the file's content hash.
 *
 * An unknown slug (a value read from the database whose file is gone) falls
 * back to the bare path: it 404s exactly as it did before, and without a tag
 * the server will not tell the browser to keep it forever.
 */
export const logoUrl = (logo: string): string => {
  const version = LOGO_VERSIONS.get(logo);
  return `/logos/${logo}.png${version === undefined ? '' : `?v=${version}`}`;
};
